import { FC, useEffect, useState } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  SimpleGrid,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import useSchedule from "hooks/use-schedule";
import TableGrid from "components/Table";
import LoadingComponent from "components/Main/Loading";
import TotalSpent from "views/admin/default/components/TotalSpent";
import useDashboard from "hooks/use-dashboard";
import TotalSpentDay from "views/admin/default/components/TotalSpentDay";
import { formatedDate } from "helpers/formated";

interface DrawerExemploProps {
  isOpen: boolean;
  fecharDrawer: () => void;
  id: any;
}

const DrawerDashboard: FC<DrawerExemploProps> = ({
  isOpen,
  fecharDrawer,
  id,
}) => {
  const { dataDay, getDataDay, loadingDrawer } = useDashboard();
  const [loading, setLoading] = useState(true);
  const bgLoading = useColorModeValue("white", "#111C44");
  const colorClose = useColorModeValue("black", "white");

  useEffect(() => {
    // if (dataDay.length === 0) {
    // if (id !== 0) {
    if (isOpen) {
      getDataDay(formatedDate(id));
      setLoading(false);
    }
    // }
    // }
  }, [isOpen]);
  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={fecharDrawer}
      size={"md"}
    >
      <DrawerOverlay />
      <DrawerContent bg={bgLoading}>
        <DrawerCloseButton color={colorClose} zIndex={100} />
        <DrawerBody mt={20} m={0} bg={bgLoading} pt={5}>
          <VStack>
            {loadingDrawer ? (
              <>
                <Box bg={bgLoading}>
                  <LoadingComponent />
                </Box>
              </>
            ) : (
              <SimpleGrid columns={{ base: 1, md: 1, xl: 1 }}>
                {dataDay.map((data) => (
                  <>
                    <TotalSpentDay data={data} />
                  </>
                ))}

                {/* <WeeklyRevenue /> */}
              </SimpleGrid>
            )}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerDashboard;
